// extracted by mini-css-extract-plugin
export default {"content":"application_content__WpriU","button":"application_button__2TAmi","footer":"application_footer__CggbV"};